import axios from "axios";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

/**
 * getVideos
 *
 * Fetches channels resource.
 *
 * @param channel_id youtube channel id
 * @returns An array of video ids.
 */

export async function getYoutubeVideos(
  args: {
    pageId: string;
    type: string;
  },
  signal?: AbortSignal
) {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.youtube_video), {
      params: {
        id: args.pageId,
        type: args.type,
      },
      signal,
    });

    if (res.data.result === false || !Array.isArray(res.data.message))
      return null;

    const videoIds: Array<string> = [];

    res.data.message.forEach((d: any) => {
      if (typeof d === "string") videoIds.push(d);
    });

    return videoIds;
  } catch (error) {
    return null;
  }
}
